import React from 'react';
import { Drawer } from '@mui/material';
import { navbarHeight } from '../../config';

import AuthButton from './AuthButton';
import CatalogList from './CatalogList';

const AuthDrawer = ({ isOpen, onClose }) => {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      variant="persistent"
      PaperProps={{ style: { width: '400px', top: navbarHeight }, }}
    >
      <AuthButton className='topmenu-button'/>
      <CatalogList />
    </Drawer>
  );
}

export default AuthDrawer;

